import React, {useEffect, useState} from "react";
import styled from "styled-components";
import PopupSelect from "./popup/Select";

export const Filter = ({title, value, options, isSticky, onChange}) => {
	if(!value) value = "";
	const getLabel = () => {
		const option = options.filter(item => {
			return (item.value == value);
		})[0] || options[0] || {};
		return option.label;
	};
	return (
		<Wrapper className={(isSticky) ? "sticky" : null}>
			<PopupSelect
				title={title} value={value}
				options={options} isIcon={true}
				onChange={onChange}
			>{getLabel()}</PopupSelect>
		</Wrapper>
	);
};

const Wrapper = styled.div`
&			{padding:8px 24px; border-top:1px solid var(--lightBorder); border-bottom:1px solid var(--lightBorder); font-size:var(--15px)}
&.sticky	{position:sticky; position:-webkit-sticky; top:52px; background-color:white; z-index:2}

`;

export default Filter;